import Footer from "../Home/Footer";
import Header from "../Home/Header";
import HeroAtt from "./HeroAtt";
import Speaker2Att from "./Speaker2Att";

function Fattendee() {
  return (
    <div>
      <div style={{ width: "100%" }}>
        <Header />
      </div>
      <HeroAtt />
      <Speaker2Att />
      <Footer />
    </div>
  );
}

export default Fattendee;
